<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
  .card
    .header
      h2
        strong Informações
    .body(v-for="i in infos")
      small.text-muted Endereço(s):
      small(v-for="tower in towers")
        br
        strong.text-muted {{ tower.address }}
      hr
      template(v-for="mp in towers")
        maps(:latitude="mp.latitude", :longitude="mp.longitude")
        br
      hr
      small.text-muted Email Contato:
      p {{ i.email }}
      hr
      small.text-muted Telefone Sindico:
      p {{ mtel(i.phone) }}
      hr
      small.text-muted Contato Central:
      p Ramal {{ i.concierge_contact }}
          hr
</template>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/overview/components/info/info.vue